import individualWorkSupportUtil from '../../../../../share/util/individualWorkSupportUtil';
import session from '../../../../../share/session';

/** 
 * 共通エラー画面OKボタン押下時 Exit API 
 * @param {object} self this インスタンス
 */
export async function exit(self) {
  try {
    self.isLoading = true;
    // バックエンドAPI POST,GET
    // ここではAPIの実行のみ
    const token = session.getToken();
    await individualWorkSupportUtil.pollingWspApi(
      self,
      self.netAppId,
      self.systemId,
      self.workSupportId,
      {
        id_token: token.id_token,
        type: self.isSession ? 'exit' : 'dispose',  // isSession=true の場合は exit API を呼び出し、false の場合は dispose API を呼び出し※セッション状態が不明な場合は安全側の処理として exit API を呼び出す
        is_special: true
      },
      // エラー発生のコールバック
      (errorType) => { errorType; self.showUnexpectedError(); },
      // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
      (result) => { self.validateErrorResult(result); },
      // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
      (result) => { self.validateErrorResult(result); },
    );

    // 結果に関わらず機能終了
    self.closeWizard();
  } finally {
    self.isLoading = false;
  }
}